import { render, staticRenderFns } from "./Redeems.vue?vue&type=template&id=10fbe0d7&scoped=true"
import script from "./Redeems.vue?vue&type=script&lang=js"
export * from "./Redeems.vue?vue&type=script&lang=js"
import style0 from "./Redeems.vue?vue&type=style&index=0&id=10fbe0d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fbe0d7",
  null
  
)

export default component.exports